/* bvc-complementary-eager-v3-reveal — replacement for the stock products-complementary.js.
   The stock version lazy-loaded via an IntersectionObserver created in the
   element constructor. This theme prerenders every internal link, and a
   prerendered page never runs its rendering pipeline, so that observer never
   fired and the block stayed empty until a hard refresh. This version does not
   depend on the rendering pipeline: it fetches on connect. */
if (!customElements.get("products-complementary")) {
  class ComplementaryProducts extends HTMLElement {
    connectedCallback() {
      if (this._bvcInit) return;
      this._bvcInit = true;
      this._bvcLoad();
    }

    _bvcLoad() {
      if (this._bvcLoaded) return;
      const url = this.dataset.url;
      if (!url) return;
      this._bvcLoaded = true;

      fetch(url)
        .then(function (r) { return r.text(); })
        .then((text) => {
          const holder = document.createElement("div");
          holder.innerHTML = text;
          const rendered = holder.querySelector("products-complementary");
          if (!rendered) {
            console.warn("No complementary content returned for this product");
            return;
          }

          // The stock version read .children off a possibly-absent <ul>, which
          // threw on every product with nothing set.
          const list = rendered.querySelector("ul");
          const wrapper = rendered.querySelector(".content-wrapper");
          if (wrapper) {
            if (!list || list.children.length === 0) {
              wrapper.setAttribute("hidden", true);
            } else {
              wrapper.removeAttribute("hidden");
            }
          }

          if (rendered.innerHTML.trim().length) {
            this.innerHTML = rendered.innerHTML;
            this.dispatchEvent(new CustomEvent("renderProductGrid", { bubbles: true }));
          }

          // Images are the one part that needs a painted page. Reveal now, and
          // again when a prerendered page is activated or the tab becomes
          // visible, since either can be the first moment painting happens.
          this._bvcReveal();
          if (document.prerendering) {
            document.addEventListener("prerenderingchange", () => this._bvcReveal(), { once: true });
          }
          document.addEventListener("visibilitychange", () => {
            if (document.visibilityState === "visible") this._bvcReveal();
          });
          window.addEventListener("pageshow", () => this._bvcReveal());
        })
        .catch(function (e) { console.error(e); });
    }

    _bvcReveal() {
      // THE ONE THAT ACTUALLY MADE IT LOOK BLANK.
      // The theme's cards ship as .reveal-item at opacity 0 / translateY(32px)
      // and are revealed by a scroll observer adding .reveal-ready. That
      // observer was set up at page load and never sees nodes injected
      // afterwards, so the injected card sat there fully built, correctly
      // sized, and completely invisible. Mark it revealed ourselves.
      this.querySelectorAll(".reveal-item:not(.reveal-ready)").forEach(function (el) {
        el.classList.add("reveal-ready");
      });

      const blur = this.querySelectorAll(".media--blur-image");
      if (!blur.length) return;
      // Ask the theme's own loader to reveal these immediately. The second
      // argument is the "enhanced" path, which loads them directly instead of
      // handing them to a lazy observer with the same missed-callback problem.
      if (typeof _preloadImg === "function") {
        try { _preloadImg(blur, true); return; } catch (e) { /* fall through */ }
      }
      // Last resort: the theme hides these with .media--blur-image img
      // { visibility: hidden } until a "loaded" class lands on the wrapper.
      blur.forEach(function (el) { el.classList.add("loaded"); });
    }
  }
  customElements.define("products-complementary", ComplementaryProducts);
}
